// extracted by css-extract-rspack-plugin
export default {"scroll_container":"styles-module__scroll_container--VvnvB"};